import React from 'react';
 
export default function checkCircle(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      style={props.style}
      width={props.size || '72.656'}
      height={props.size || '72.656'}
      viewBox="0 0 72.656 72.656"
    >
      <path d="M37.5-64.453A36.328,36.328,0,0,0,1.172-28.125,36.328,36.328,0,0,0,37.5,8.2,36.328,36.328,0,0,0,73.828-28.125,36.328,36.328,0,0,0,37.5-64.453Zm0,7.031a29.281,29.281,0,0,1,29.3,29.3,29.281,29.281,0,0,1-29.3,29.3,29.281,29.281,0,0,1-29.3-29.3A29.281,29.281,0,0,1,37.5-57.422ZM58.038-38.34l-3.3-3.328a1.758,1.758,0,0,0-2.486-.01L31.545-21.138l-8.759-8.83a1.758,1.758,0,0,0-2.486-.01l-3.328,3.3a1.758,1.758,0,0,0-.01,2.486l13.3,13.406a1.758,1.758,0,0,0,2.486.01L58.028-35.854A1.758,1.758,0,0,0,58.038-38.34Z" transform="translate(-1.172 64.453)"/>
    </svg> );
}